import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-score-card',
  templateUrl: './print-score-card.component.html',
  styleUrls: ['./print-score-card.component.scss']
})
export class PrintScoreCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
